/* Elementi consent-gated baseline. Public token placeholder only. */
(function(w){
 'use strict';
 var s=w.Shopify,t=s&&s.theme,q=new URLSearchParams(w.location.search);
 function sensitive(){return /^\/(?:account|accounts|checkout|checkouts|orders|apps)(?:\/|$)/.test(w.location.pathname);}
 function preview(){return !!(s&&s.designMode===true)||q.has('preview_theme_id')||q.has('preview_key')||q.has('preview_path')||q.has('theme_preview')||q.has('pb');}
 if(!t||String(t.id)!=='185160925229'||String(t.role).toLowerCase()!=='main'||sensitive()||preview())return;
 w.elementiPosthogBaseline=w.ElementiPostHogBootstrap.install({captureToken:'phc_ALjuaSqrvZduTg8jVgJTwcyX46VTajvMsBPiuQYNEJP2'});
})(window);
